const axios = require('axios');

import {
	serverUrl,
	presighnedUrl
} from '../properties'
const dataUrl = serverUrl;

export default {
	namespaced: true,
	state: {
		automationList: [],
		actionTypeList: [],
		showEditConditionLoaderVal: false,
		actionList: [],
		conditionList: [],
		automationCount: 0,
		owner:'Me',
		target:'All',
		subTarget:null,
		subTargetValue:null,
		advanceFilterAutomation:{}
	},
	mutations: {
		setadvanceFilterAutomation: (state, data) => {
			state.advanceFilterAutomation = data
		},
		updateAutomationList: (state, data) => {
			state.automationList = data
		},
		updateActionTypeList: (state, data) => {
			state.actionTypeList = []
			data.forEach(item => {
				state.actionTypeList.push({
					action_id: item.id,
					name: item.title,
					type: item.type,
					entity_data_type: item.entity_data_type,
					action_type: item.action_type
				})
			})
		},
		updateActionList: (state, data) => {
			state.actionList = data
		},
		updateConditionList: (state, data) => {
			state.conditionList = data
		},
		updateAutomationCount: (state, data) => {
			state.automationCount  = data
		}
	},
	getters: {
		recieveAuomationCount: (state, getters) => {
			return state.automationCount
		}
	},
	actions: {
		getAutomations({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				if (payload && payload.hideLoader) {

				} else {
					commit('showLoadingSpinner', null, {
						root: true
					})
				}

				let queryString = {
					// resultsPerPage: rootGetters.getShowPerPage,
					resultsPerPage: sessionStorage.getItem("automation:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					target:state.target && state.target!='All'?state.target:''
				}

				if(state.owner == 'Me'){
					queryString.owner =  JSON.parse(window.localStorage.session).name;
				}
				// if(state.target && state.subTarget && state.subTarget.type && state.subTargetValue){
				// 	queryString[state.subTarget.type]=''
				// 	queryString[state.subTarget.type] = state.subTargetValue.name || state.subTargetValue
				// }


				let url = dataUrl + "/automation/list"
				axios({
					url: url,
					method: 'POST',
					data: queryString,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					commit('hideLoadingSpinner', null, {
						root: true
					})
					if(response.data && response.data.list){
						commit('updateAutomationList', response.data.list)
						commit('updateAutomationCount',response.data.count)
					}
					else{
						commit('updateAutomationList', response.data)
					}
				}).catch((error) => {
					commit('hideLoadingSpinner', null, {
						root: true
					})
					console.log(error.response);
				})
			})

		},

		getAutomationsFiltered({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				if (payload && payload.hideLoader) {

				} else {
					commit('showLoadingSpinner', null, {
						root: true
					})
				}

				let queryString = {
					// resultsPerPage: rootGetters.getShowPerPage,
					resultsPerPage: sessionStorage.getItem("automation:showPerPage"),
					pageNumber: rootGetters.getCurrentPageNumber,
					target:state.target && state.target!='All'?state.target:''
				}

				if(state.owner == 'Me'){
					queryString.owner =  JSON.parse(window.localStorage.session).name;
				}
				if(state.target && state.subTarget && state.subTarget.type && state.subTargetValue){
					queryString[state.subTarget.type]=''
					if(state.subTarget.type =='vendor'){
						queryString[state.subTarget.type] = state.subTargetValue.id||''
					}
					if(state.subTarget.type =='brand'){
						queryString[state.subTarget.type] = state.subTargetValue.id||''
					}
					if(state.subTarget.type =='campaign'){
						queryString[state.subTarget.type] = (state.subTargetValue.ams_campaign_id)||''
					}
					if(state.subTarget.type =='campaign_group'){
						queryString[state.subTarget.type] = state.subTargetValue.id || ''
					}
					if(state.subTarget.type =='asin'){
						queryString[state.subTarget.type] = state.subTargetValue||''
					}
				}
				// queryString.vendor =  (state.advanceFilterAutomation && state.advanceFilterAutomation.hasOwnProperty('vendor') ? state.advanceFilterAutomation.vendor : null);
				// queryString.brand =  (state.advanceFilterAutomation && state.advanceFilterAutomation.hasOwnProperty('brand') ? state.advanceFilterAutomation.brand : null);
				// queryString.keyword =  (state.advanceFilterAutomation && state.advanceFilterAutomation.hasOwnProperty('keyword') ? state.advanceFilterAutomation.keyword : null);
				// queryString.product =  (state.advanceFilterAutomation && state.advanceFilterAutomation.hasOwnProperty('product') ? state.advanceFilterAutomation.product : null);
				// queryString.campaign =  (state.advanceFilterAutomation && state.advanceFilterAutomation.hasOwnProperty('campaign') ? state.advanceFilterAutomation.campaign : null);
				// queryString.campaign_group =  (state.advanceFilterAutomation && state.advanceFilterAutomation.hasOwnProperty('campaign_group') ? state.advanceFilterAutomation.campaign_group : null);


				let url = dataUrl + "/automation/filteredList"
				axios({
					url: url,
					method: 'POST',
					data: queryString,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					commit('hideLoadingSpinner', null, {
						root: true
					})
					if(response.data && response.data.list){
						commit('updateAutomationList', response.data.list)
						commit('updateAutomationCount',response.data.count)
					}
					else{
						commit('updateAutomationList', response.data)
					}
				}).catch((error) => {
					commit('hideLoadingSpinner', null, {
						root: true
					})
					console.log(error.response);
				})
			})

		},

		addUpdateAutomation({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {

				payload.userName = JSON.parse(window.localStorage.session).name;
				let url = dataUrl + "/automation/addUpdate"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		editAutomationCondition({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			//state.showEditConditionLoaderVal = true
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				let url = dataUrl + "/automation/editTrigger"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
					//	state.showEditConditionLoaderVal = false
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		addAutomationCondition({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				payload.userName = JSON.parse(window.localStorage.session).name;
				let url = dataUrl + "/automation/addTrigger"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		showScopeData({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/getScopeList"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getActionTypeList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				// commit('showLoadingSpinner', null, {
				// 	root: true
				// })
				let url = dataUrl + "/automation/actionList"
				axios({
					url: url,
					data: payload,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: payload,
					responseType: 'json'
				}).then((response) => {
					// commit('hideLoadingSpinner', null, {
					// 	root: true
					// })
					resolve(response.data)
					commit('updateActionTypeList', response.data)
				}).catch((error) => {
					commit('hideLoadingSpinner', null, {
						root: true
					})
					console.log(error.response);
				})
			})

		},
		updateAutomation({
			commit,
			state,
			getters,
			rootGetters,
			rootState,
			dispatch
		}, payload) {
			return new Promise((resolve, reject) => {
				//     commit('showLoadingSpinner', null, {
				// 		root: true
				// 	})
				payload.userName = JSON.parse(window.localStorage.session).name;
				let url = dataUrl + "/automation/actions"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					// commit('hideLoadingSpinner', null, {
					// 	root: true
					// })
					resolve(response)
				}).catch((error) => {
					// commit('hideLoadingSpinner', null, {
					// 	root: true
					// })
					console.log(error.response);
				})
			})


		},
		editAction({
			commit,
			state,
			getters,
			rootGetters,
			rootState,
			dispatch
		}, payload) {
			return new Promise((resolve, reject) => {
				//     commit('showLoadingSpinner', null, {
				// 		root: true
				// 	})
				payload.userName = JSON.parse(window.localStorage.session).name;

				let url = dataUrl + "/automation/editAction"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					// commit('hideLoadingSpinner', null, {
					// 	root: true
					// })
					resolve(response)
				}).catch((error) => {
					// commit('hideLoadingSpinner', null, {
					// 	root: true
					// })
					console.log(error.response);
				})
			})


		},
		updateActionAsPerTarget({
			commit,
			state,
			getters,
			rootGetters,
			rootState,
			dispatch
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/disableAction"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		getAutomationDataById({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/get"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		addUpdateGuardRail({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/guardRailSave"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getAttributeList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/getAttributeList"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		getScheduleList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/getScheduleData"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		DelAction({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/del"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})

		},
		setRowInactive({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/disableRuleSet"
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		getConditionList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/getAllConditions"
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					commit('updateConditionList', response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		getActionList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload) {
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/getAllActions"
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					commit('updateActionList', response.data)

				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		getTagsList({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload){
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/tagList";
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
		getPresighnedURL({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload){
			return new Promise((resolve, reject) => {
				let url = presighnedUrl;
				let data = {
					"contentType": "text/csv",
					"ext": "csv"
				}
				axios({
					url: url,
					method: 'POST',
					headers: rootGetters.fetchHeader,
					data: data
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		uploadFile({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload){
			return new Promise((resolve, reject) => {
				axios({
					url: payload.url,
					method: 'PUT',
					headers: rootGetters.fetchHeader,
					data: payload.data,
					headers: {'Content-Type': 'text/csv'},
					responseType: 'json'
				}).then((response) => {
					console.log(response.data);
					resolve(response.data)
				}).catch((error) => {
					console.log(error);
				})
			})
		},
		saveTemplateForGuardrail({
			commit,
			state,
			getters,
			rootGetters,
			rootState
		}, payload){
			return new Promise((resolve, reject) => {
				let url = dataUrl + "/automation/addTemplate";
				axios({
					url: url,
					method: 'POST',
					data: payload,
					headers: rootGetters.fetchHeader,
					responseType: 'json'
				}).then((response) => {
					resolve(response.data)
				}).catch((error) => {
					console.log(error.response);
				})
			})
		},
	}
}
